import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, PagedResult, PageInfo, SmBaseService } from '../../core';

@Injectable()
export class NewsService extends SmBaseService {
	constructor(http: HttpService) {
		super(http, 'news');
	}

	getLatestNews(page?: number, perPage?: number): Observable<PagedResult<NewsModel>> {
		return this._getAs<PagedResult<NewsModel>>('', {
			params: this.getPagerParams(page, perPage)
		});
	}

	getDetail(id: number, page?: number, perPage?: number): Observable<NewsDetailModel> {
		return this._getAs<NewsDetailModel>(id || 0, {
			params: this.getPagerParams(page, perPage)
		});
	}

	private getPagerParams(page?: number, perPage?: number): { [key: string]: string } {
		let params: { [key: string]: string } = {};

		if (page != null) {
			params['page'] = '' + page;
		}

		if (perPage != null) {
			params['perpage'] = '' + perPage;
		}

		return params;
	}
}

export interface NewsDetailModel {
	detail?: NewsModel;
	pageInfo: PageInfo;
	items: any;
}

export interface NewsModel {
	id: number;
	title: string;
	content: string;
	publishedAt: Date;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/news.service.ts